import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigDrawerComponent } from '@ui/products/products-front/components/config-drawer/config-drawer.component';
import { ZalamoTooltipModule } from '@ui/zalamo-tooltip/zalamo-tooltip.module';
import { ProductParamPickerComponent } from '@ui/products/products-front/components/product-param-picker/product-param-picker.component';
import { LanguageModule } from 'ZalamoLibrary/src/lib/zalamo/language/language.module';
import { CheckboxModule } from '@ui/form/checkbox/checkbox.module';
import { NumberPickerModule } from '@ui/change-number/change-number.module';
import { CalculateMinValueIncludingPhotographerConfigPipe } from '@ui/products/products-front/components/config-drawer/calculate-min-value-including-photographer-config.pipe';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FormModule } from '@ui/form/form.module';
import { SkipPickedByPhotographerPipe } from '@ui/products/products-front/components/config-drawer/skip-picked-by-photographer.pipe';
import { MatSelectModule } from '@angular/material/select';
import { ImagesModule } from '@ui/images/images.module';
import { TranslationsModule } from '@ui/nls/translations/translations.module';

@NgModule({
  declarations: [
    ConfigDrawerComponent,
    ProductParamPickerComponent,
    CalculateMinValueIncludingPhotographerConfigPipe,
    SkipPickedByPhotographerPipe,
  ],
  exports: [ConfigDrawerComponent, ProductParamPickerComponent],
  imports: [
    CommonModule,
    ZalamoTooltipModule,
    LanguageModule,
    CheckboxModule,
    NumberPickerModule,
    ReactiveFormsModule,
    MatInputModule,
    FormModule,
    MatSelectModule,
    ImagesModule,
    TranslationsModule,
  ],
})
export class ProductConfigDrawerModule {}
